export default __webpack_public_path__ + "static/media/01.5977e645.jpg";